<template>
    <div class="po-admin-nav-wrap">
        <nav class="navbar navbar-dark po-admin-nav po-admin-nav--mobile d-lg-none">
            <div class="container-fluid">
                <router-link class="navbar-brand fw-semibold d-flex align-items-center gap-2 min-w-0" to="/u/home">
                    <span class="text-truncate">{{ leerNombre() }}</span>
                </router-link>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-light rounded-pill flex-shrink-0"
                    data-bs-toggle="modal"
                    data-bs-target="#adminLogoutModal"
                    title="Cerrar sesión"
                >
                    <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </nav>

        <div class="po-bottom-nav po-admin-bottom-nav d-lg-none">
            <router-link
                v-for="item in navItems"
                :key="item.to"
                :to="item.to"
                class="po-bottom-nav__item"
                :title="item.label"
            >
                <i class="bi po-bottom-nav__ico" :class="item.icon" aria-hidden="true"></i>
                <span>{{ item.shortLabel || item.label }}</span>
            </router-link>
        </div>

        <aside
            class="po-sidebar po-admin-sidebar d-none d-lg-flex flex-column"
            :class="{ 'po-sidebar--expanded': sidebarExpanded }"
        >
            <button
                type="button"
                class="po-sidebar__toggle"
                :aria-expanded="sidebarExpanded ? 'true' : 'false'"
                :aria-label="sidebarExpanded ? 'Contraer menú' : 'Expandir menú'"
                :title="sidebarExpanded ? 'Contraer menú' : 'Expandir menú'"
                @click="toggleSidebarExpanded"
            >
                <i class="bi" :class="sidebarExpanded ? 'bi-chevron-left' : 'bi-chevron-right'" aria-hidden="true"></i>
            </button>


            <nav class="po-sidebar__section">
                <router-link
                    v-for="item in navItems"
                    :key="item.to"
                    :to="item.to"
                    class="po-sidebar__item"
                    :class="{ 'po-sidebar__item--accent': item.accent }"
                    :data-tooltip="item.label"
                    :aria-label="item.label"
                >
                    <i class="bi" :class="item.icon" aria-hidden="true"></i>
                    <span class="po-sidebar__label">{{ item.label }}</span>
                </router-link>
            </nav>

            <div class="po-sidebar__spacer"></div>

            <div class="po-sidebar__section">
                <button
                    type="button"
                    class="po-sidebar__item"
                    data-tooltip="Cerrar sesión"
                    aria-label="Cerrar sesión"
                    data-bs-toggle="modal"
                    data-bs-target="#adminLogoutModal"
                >
                    <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
                    <span class="po-sidebar__label">Cerrar sesión</span>
                </button>
            </div>
        </aside>

        <ConfirmLogoutModal modal-id="adminLogoutModal" @confirm="cerrarSesion" />
    </div>
</template>

<script>
import { RouterLink } from 'vue-router';
import router from '@/router';
import ConfirmLogoutModal from '@/components/shared/ConfirmLogoutModal.vue';
import { clearSession } from '@/utils/session';
import {
    sidebarExpandState,
    toggleSidebarExpanded,
    syncSidebarExpandCss,
} from '@/utils/sidebarExpand';

export default {
    components: {
        'router-link': RouterLink,
        ConfirmLogoutModal,
    },
    data() {
        return {
            navItems: [
                { to: '/u/home', label: 'Panel', shortLabel: 'Panel', icon: 'bi-speedometer2' },
                { to: '/u/negocios', label: 'Negocios', shortLabel: 'Negocios', icon: 'bi-building' },
                { to: '/u/admin/pagos', label: 'Pagos', shortLabel: 'Pagos', icon: 'bi-cash-stack' },
                {
                    to: '/u/admin/negocios/nuevo',
                    label: 'Nuevo negocio',
                    shortLabel: 'Nuevo',
                    icon: 'bi-person-plus'
                },
                { to: '/u/logs', label: 'Actividad', shortLabel: 'Logs', icon: 'bi-clock-history' },
            ],
        };
    },
    computed: {
        sidebarExpanded() {
            return sidebarExpandState.expanded;
        },
    },
    mounted() {
        syncSidebarExpandCss();
    },
    methods: {
        toggleSidebarExpanded,
        leerNombre() {
            return localStorage.getItem('nombre') || 'Administrador';
        },
        cerrarSesion() {
            clearSession();
            router.push('/');
        },
    },
};
</script>

<style scoped>
.po-admin-nav-wrap {
    position: relative;
}

.po-admin-nav {
    background: linear-gradient(90deg, #1e1b4b 0%, #312e81 100%);
    box-shadow: 0 2px 12px rgba(30, 27, 75, 0.3);
}

.po-admin-nav--mobile {
    min-height: 52px;
}

.po-admin-brand__badge {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.12);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.navbar-brand {
    color: #fff !important;
}

/* Variante de color del sidebar de escritorio para el panel de administración
   (clases base .po-sidebar* compartidas: ver global-ui.css) */
.po-admin-sidebar {
    background: linear-gradient(180deg, #1e1b4b 0%, #312e81 100%);
}

.po-admin-sidebar .po-sidebar__item.active::before,
.po-admin-sidebar .po-sidebar__item--active::before {
    background: #a5b4fc;
}

.po-admin-sidebar .po-sidebar__item--accent {
    background: rgba(129, 140, 248, 0.32);
}

.po-admin-sidebar .po-sidebar__item--accent:hover {
    background: rgba(129, 140, 248, 0.48);
}

.po-admin-bottom-nav {
    display: none;
}

@media screen and (max-width: 991.98px) {
    .po-admin-bottom-nav {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1040;
        background: linear-gradient(180deg, #1e1b4b 0%, #312e81 100%);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        padding: 0.35rem 0.15rem calc(0.35rem + env(safe-area-inset-bottom, 0));
        justify-content: space-around;
        align-items: center;
    }

    .po-admin-bottom-nav .po-bottom-nav__item {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.15rem;
        text-decoration: none;
        color: #c7d2fe;
        font-size: 0.62rem;
        font-weight: 600;
        padding: 0.25rem 0.1rem;
        min-width: 0;
        transition: color 0.2s ease;
    }

    .po-admin-bottom-nav .po-bottom-nav__item:hover,
    .po-admin-bottom-nav .po-bottom-nav__item.active {
        color: #fff;
    }

    .po-admin-bottom-nav .po-bottom-nav__ico {
        font-size: 1.25rem;
        line-height: 1;
    }
}
</style>
